// Briefanrede – muss mit backend/salutation.py übereinstimmen.
// privat: Anrede + Kundenname; gewerbe: Anrede + Ansprechperson.
export function contactName(customer) {
  if (!customer) return "";
  const n = customer.objekt_art === "gewerbe" ? customer.ansprechpartner : customer.name;
  return (n || "").trim();
}

function surname(fullName) {
  if (fullName.includes(",")) return fullName.split(",")[0].trim();
  const parts = fullName.split(/\s+/).filter(Boolean);
  return parts[parts.length - 1] || "";
}

export function greetingFor(customer) {
  const name = contactName(customer);
  if (name && customer.anrede === "herr") return `Sehr geehrter Herr ${surname(name)},`;
  if (name && customer.anrede === "frau") return `Sehr geehrte Frau ${surname(name)},`;
  if (customer?.objekt_art === "gewerbe" && !name) return "Sehr geehrte Damen und Herren,";
  return `Sehr geehrte/r ${name || customer?.name || ""},`;
}
